const { $ } = window;
//const $body = $( document.body )

export default {
	init() {
		let paged = 1;
		const $loadMore = $( '.archive-load-btn' );
		const $container = $( '.archive-post-wrap' );
		const postType = $container.data( 'post-type' );
		const category = $container.data( 'category' );

		if ( $container.find( '.archive-post, .single-article' ).length < +$container.data( 'initial-total' ) ) {
			$loadMore.hide();
		}

		$loadMore.on( 'click', function() {
			paged++;

			$.ajax( {
				type: 'POST',
				url: '/wp-admin/admin-ajax.php',
				dataType: 'html',
				data: {
					action: 'archive_load_more',
					postType,
					category,
					paged,
				},
				success( res ) {
					$container.append( res );
					if ( $container.find( '.archive-post, .single-article' ).length === +$container.data( 'total' ) ) {
						$loadMore.hide();
					}
				},
				error( err ) {
					// eslint-disable-next-line no-console
					console.error( err );
				},
			} );
		} );
	},
	finalize() {

	},
};
